<template>
  <div class="tc-container">
    <div class="tc-chart">
      <ul>
        <li :class="actvIndex == 1 ? 'is-active' : ''" @click="handSelect(1)">
          今日
        </li>
        <li :class="actvIndex == 2 ? 'is-active' : ''" @click="handSelect(2)">
          近七日
        </li>
        <li :class="actvIndex == 3 ? 'is-active' : ''" @click="handSelect(3)">
          本月
        </li>
        <li :class="actvIndex == 4 ? 'is-active' : ''" @click="handSelect(4)">
          本年
        </li>
      </ul>
      <div class="myChart" ref="myChart" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'connection-statistics',
    data() {
      return {
        actvIndex: 3,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          tooltip: {},
          backgroundColor: 'rgba(0, 0, 0, 0)',
          animation: true,
          grid: {
            top: '5%',
            left: '3%',
            right: '3%',
            bottom: '30%', //也可设置left和right设置距离来控制图表的大小
          },
          xAxis: {
            data: [
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
              '13',
              '14',
              'H',
            ],
            axisLine: {
              show: true, //隐藏X轴轴线
              lineStyle: {
                color: '#FFFFFF',
              },
            },
            axisTick: {
              show: false, //隐藏X轴刻度
            },
            axisLabel: {
              show: true,
              margin: 14,
              fontSize: 14,
              textStyle: {
                color: '#FFFFFF', //X轴文字颜色
              },
            },
          },
          yAxis: [
            {
              type: 'value',
              gridIndex: 0,
              min: 0,
              max: 100,
              interval: 25,
              // splitNumber: 4,
              splitLine: {
                show: true,
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.3)',
                  width: 1,
                },
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
            },
          ],
          series: [
            {
              name: '连接时长统计',
              type: 'bar',
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#04e090',
                    },
                    {
                      offset: 1,
                      color: 'rgba(15,20,22,0.11)',
                    },
                  ]),
                },
              },
              data: [
                100, 90, 80, 100, 80, 90, 100, 90, 80, 100, 80, 90, 80, 90,
              ],
              z: 10,
              zlevel: 0,
            },
            {
              // 分隔
              type: 'pictorialBar',
              itemStyle: {
                normal: {
                  color: '#191f21',
                },
              },
              symbolRepeat: 'fixed',
              symbolMargin: 3,
              symbol: 'rect',
              symbolClip: true,
              symbolSize: [10, 2],
              symbolPosition: 'start',
              symbolOffset: [0, -1],
              // symbolBoundingData: this.total,
              data: [
                100, 90, 80, 100, 80, 90, 100, 90, 80, 100, 80, 90, 80, 90,
              ],
              width: 10,
              z: 0,
              zlevel: 1,
            },
          ],
        })
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tc-container {
    width: 100%;

    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      color: #15a983;
      cursor: pointer;

      li {
        margin-right: 30px;
        white-space: nowrap;
      }

      .is-active {
        border-bottom: 1px solid #ffc600;
        padding-bottom: 7px;
        position: relative;
        color: #fff;

        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: 5px solid #ffc600;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          bottom: 0px;
          left: 37%;
        }
      }
    }

    .tc-chart {
      width: 100%;
      height: 7.552vw;
      margin: 0 auto;

      .myChart {
        width: 100%;
        height: 7.552vw;
      }
    }
  }
</style>
